import React from 'react'

const CompanyPage = () => {
	return <div>Company Page</div>
}

export default CompanyPage
